const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_745",
  "data-name": "Rectangle 745",
  width: 17.822,
  height: 21.362,
  fill: "#707070"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2706",
  "data-name": "Group 2706",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2407",
  "data-name": "Path 2407",
  d: "M74.77,10.29a4.978,4.978,0,0,0,3.638-1.507,4.979,4.979,0,0,0,1.507-3.638,4.978,4.978,0,0,0-1.507-3.638,5.144,5.144,0,0,0-7.275,0,4.978,4.978,0,0,0-1.507,3.638,4.978,4.978,0,0,0,1.507,3.638A4.98,4.98,0,0,0,74.77,10.29m-2.753-7.9a3.892,3.892,0,0,1,5.505,0,3.72,3.72,0,0,1,1.141,2.752A3.72,3.72,0,0,1,77.523,7.9a3.891,3.891,0,0,1-5.505,0,3.719,3.719,0,0,1-1.141-2.753,3.719,3.719,0,0,1,1.141-2.752",
  transform: "translate(-65.994)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2408",
  "data-name": "Path 2408",
  d: "M17.779,203.959a12.716,12.716,0,0,0-.173-1.35,10.623,10.623,0,0,0-.332-1.357,6.715,6.715,0,0,0-.558-1.266,4.766,4.766,0,0,0-.841-1.1,3.709,3.709,0,0,0-1.208-.759,4.175,4.175,0,0,0-1.543-.279,1.565,1.565,0,0,0-.836.355c-.251.163-.544.352-.871.562a4.991,4.991,0,0,1-1.127.5,4.375,4.375,0,0,1-2.757,0,4.973,4.973,0,0,1-1.126-.5c-.324-.207-.617-.4-.872-.562a1.566,1.566,0,0,0-.836-.355,4.171,4.171,0,0,0-1.543.279,3.705,3.705,0,0,0-1.209.759,4.774,4.774,0,0,0-.841,1.1,6.716,6.716,0,0,0-.558,1.266,10.611,10.611,0,0,0-.332,1.357,12.619,12.619,0,0,0-.173,1.35c-.028.408-.043.832-.043,1.261a3.547,3.547,0,0,0,1.053,2.684,3.793,3.793,0,0,0,2.715.99H14.054a3.793,3.793,0,0,0,2.715-.99,3.546,3.546,0,0,0,1.054-2.684c0-.43-.015-.855-.043-1.262M15.905,207a2.553,2.553,0,0,1-1.852.645H3.768A2.552,2.552,0,0,1,1.917,207a2.316,2.316,0,0,1-.665-1.777c0-.4.013-.8.04-1.175a11.37,11.37,0,0,1,.156-1.216,9.382,9.382,0,0,1,.292-1.2,5.46,5.46,0,0,1,.454-1.029,3.535,3.535,0,0,1,.618-.81,2.456,2.456,0,0,1,.8-.5,2.878,2.878,0,0,1,.986-.19c.044.023.122.068.249.15.257.168.554.359.882.569a6.213,6.213,0,0,0,1.415.632,5.628,5.628,0,0,0,3.527,0,6.214,6.214,0,0,0,1.415-.633c.336-.215.624-.4.881-.568.127-.082.2-.127.248-.15a2.879,2.879,0,0,1,.986.19,2.464,2.464,0,0,1,.8.5,3.526,3.526,0,0,1,.618.81,5.456,5.456,0,0,1,.454,1.029,9.384,9.384,0,0,1,.292,1.2,11.429,11.429,0,0,1,.156,1.216h0c.027.378.04.773.04,1.174A2.317,2.317,0,0,1,15.905,207",
  transform: "translate(0 -187.534)",
  fill: "#707070"
}));
function SvgIconfeatherUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2707",
    "data-name": "Group 2707",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.822,
    height: 21.362,
    viewBox: "0 0 17.822 21.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherUser);
export default __webpack_public_path__ + "static/media/Icon feather-user.d9428cd3.svg";
export { ForwardRef as ReactComponent };